<template>
  <div class="mobile-floating-bar">
    <!-- 위: 동호수 빠르게 소진 中 -->
    <div class="bar-top">
      <span class="open-text">동호수 빠르게 소진 中</span>
      <div class="fake-applicants">
        <span class="fake-item" v-for="(item, i) in fakeApplicants" :key="i"
          :style="{ animationDelay: (i * 3) + 's' }">
          {{ item }}
        </span>
      </div>
    </div>

    <!-- 둥둥 떠다니는 신청 카운터 -->
    <div class="float-counter">
      <span>지금 <strong class="count-number"><span
        v-for="(digit, i) in displayDigits"
        :key="i"
        class="slot-digit"
        :class="{ 'slot-spinning': isSpinning }"
        :style="{ animationDelay: (i * 0.15) + 's', animationDuration: (0.8 + i * 0.3) + 's' }"
      >{{ digit }}</span>명</strong>이 신청했어요</span>
    </div>
    <!-- 아래: 전화 + 관심고객등록 -->
    <div class="bar-bottom">
      <a href="tel:1599-9923" class="bar-btn bar-phone">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
          <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.57.57a1 1 0 011 1v3.49a1 1 0 01-1 1C10.07 22 2 13.93 2 3.01a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.45.57 3.57a1 1 0 01-.24 1.01l-2.2 2.2z"/>
        </svg>
        <span class="phone-number">1599.9923</span>
      </a>
      <div class="bar-divider"></div>
      <button class="bar-btn bar-register" @click="openRegister">
        <span class="register-main">관심고객등록</span>
        <span class="register-sub">분양가 상한제로 6억원대부터!</span>
      </button>
    </div>
  </div>

  <!-- 모바일 즉시전화 팝업 (1단계: 분양가상한제 → 2단계: 진라면 → register) -->
  <transition name="register-popup">
    <div v-if="showCallPopup" class="call-overlay" @click.self="closeCallPopup">
      <div class="call-popup-modal">
        <button class="call-popup-close" @click="closeCallPopup">✕</button>

        <!-- 1단계: 분양가상한제 -->
        <div v-if="mobilePopupStep === 1" class="call-popup-inner">
          <div class="call-badge">분양가상한제</div>
          <h2 class="call-title">84타입 6억대</h2>
          <p class="call-sub">신분당선 연장선 프리미엄 기대</p>
          <div class="call-divider"></div>
          <p class="call-status">방문예약 상담접수 진행중</p>
          <div class="call-hero">
            <img :src="heroImg" alt="조감도" class="call-hero-img" />
          </div>
          <a href="tel:1599-9923" class="call-btn" @click="closeAndRegister">
            <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
              <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.57.57a1 1 0 011 1v3.49a1 1 0 01-1 1C10.07 22 2 13.93 2 3.01a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.45.57 3.57a1 1 0 01-.24 1.01l-2.2 2.2z"/>
            </svg>
            <span>바로 전화하기</span>
            <strong>1599-9923</strong>
          </a>
        </div>

        <!-- 2단계: 진라면 사은품 -->
        <div v-else class="call-popup-inner">
          <div class="call-badge">사은품 증정</div>
          <h2 class="call-title">진라면 5개입 증정</h2>
          <p class="call-sub">지금 상담신청하고 방문하면</p>
          <div class="call-divider"></div>
          <p class="call-status">방문예약 후 방문시 (소진시까지)</p>
          <div class="call-hero">
            <img :src="jinramenImg" alt="진라면 5개입" class="call-hero-img" />
          </div>
          <a href="tel:1599-9923" class="call-btn" @click="closeAndRegister">
            <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
              <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.57.57a1 1 0 011 1v3.49a1 1 0 01-1 1C10.07 22 2 13.93 2 3.01a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.45.57 3.57a1 1 0 01-.24 1.01l-2.2 2.2z"/>
            </svg>
            <span>바로 전화하기</span>
            <strong>1599-9923</strong>
          </a>
          <button type="button" class="reserve-btn-mobile" @click="closeAndRegister">
            상담신청하기
          </button>
        </div>
      </div>
    </div>
  </transition>

  <!-- 관심고객등록 폼 -->
  <transition name="register-popup">
    <div v-if="showRegister" class="register-overlay" @click.self="closeRegister">
      <div class="register-modal register-fullform">
        <div class="register-header">
          <h3 class="register-title">관심고객등록</h3>
          <button class="register-close" @click="closeRegister">
            <span></span>
            <span></span>
          </button>
        </div>

        <div class="register-body" v-if="!isSubmitted">
          <div class="register-coupon-row">
            <p class="register-desc">
              관심을 가져주셔서 감사합니다.<br/>
              분양정보를 빠르게 알아보세요
            </p>
          </div>

          <form @submit.prevent="submitForm" class="register-form">
            <div class="form-group">
              <label class="form-label">이름 <span class="required">*</span></label>
              <input
                v-model="formData.name"
                type="text"
                class="form-input"
                placeholder="이름을 입력해주세요"
                required
              />
            </div>

            <div class="form-group">
              <label class="form-label">연락처 <span class="required">*</span></label>
              <div class="phone-inputs">
                <input
                  ref="phone1"
                  v-model="formData.phone1"
                  type="tel"
                  inputmode="numeric"
                  class="form-input phone-field"
                  placeholder="010"
                  maxlength="3"
                  required
                  @input="onPhoneInput('phone1', 3, 'phone2')"
                />
                <span class="phone-dash">-</span>
                <input
                  ref="phone2"
                  v-model="formData.phone2"
                  type="tel"
                  inputmode="numeric"
                  class="form-input phone-field"
                  placeholder="0000"
                  maxlength="4"
                  required
                  @input="onPhoneInput('phone2', 4, 'phone3')"
                />
                <span class="phone-dash">-</span>
                <input
                  ref="phone3"
                  v-model="formData.phone3"
                  type="tel"
                  inputmode="numeric"
                  class="form-input phone-field"
                  placeholder="0000"
                  maxlength="4"
                  required
                  @input="onPhoneInput('phone3', 4, null)"
                />
              </div>
            </div>

            <div class="form-group">
              <label class="form-label">희망 방문일시</label>
              <div class="visit-inputs">
                <div class="visit-field-wrap">
                  <svg class="visit-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                  <input v-model="formData.visitDay" type="date" class="form-input visit-field" :min="today" />
                </div>
                <div class="visit-field-wrap">
                  <svg class="visit-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                  <select v-model="formData.visitTime" class="form-input visit-field">
                    <option value="">시간 선택</option>
                    <option v-for="t in timeSlots" :key="t" :value="t">{{ t }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="form-group agreement">
              <div class="agreement-header">
                <label class="checkbox-label">
                  <input
                    v-model="formData.agree"
                    type="checkbox"
                    class="checkbox-input"
                    required
                  />
                  <span class="checkbox-custom"></span>
                  <span class="checkbox-text">개인정보 수집 및 이용 동의 <span class="required">*</span></span>
                </label>
                <button type="button" class="toggle-btn" @click="showPrivacy = !showPrivacy">
                  {{ showPrivacy ? '닫기' : '보기' }}
                </button>
              </div>
              <div class="privacy-content" :class="{ visible: showPrivacy }">
                <p>
                  <strong>1. 수집하는 개인정보 항목</strong><br />이름, 연락처, 희망 방문일시
                </p>
                <p>
                  <strong>2. 수집 및 이용 목적</strong><br />분양 관련 상담 및 정보 제공
                </p>
                <p>
                  <strong>3. 보유 및 이용 기간</strong><br />수집일로부터 1년간 보관 후 파기
                </p>
              </div>
            </div>

            <button type="submit" class="submit-btn" :disabled="isSubmitting">
              <span v-if="!isSubmitting">상담신청하기</span>
              <span v-else>전송 중...</span>
            </button>
          </form>
        </div>

        <!-- 성공 -->
        <div v-else class="register-success">
          <div class="success-icon">✓</div>
          <h3>신청이 완료되었습니다</h3>
          <p>빠른 시일 내에 연락드리겠습니다.</p>
          <button @click="resetForm" class="reset-btn">닫기</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { registerCustomer } from '@/firebase/customerService'
import heroImg from '@/assets/조감도.jpg'
import jinramenImg from '@/assets/promo/진라면.jpg'

export default {
  name: 'MobileFloatingBar',
  data() {
    return {
      showCallPopup: false,
      mobilePopupStep: 1,
      showRegister: false,
      heroImg,
      jinramenImg,
      showPrivacy: false,
      isSubmitting: false,
      isSubmitted: false,
      applicantCount: 313,
      displayDigits: ['0', '0', '0'],
      isSpinning: false,
      countTimer: null,
      spinTimer: null,
      fakeApplicants: [
        '김X영 / 010-7389-****',
        '이X준 / 010-5523-****',
        '박X현 / 010-9912-****',
        '최X서 / 010-3347-****',
        '정X민 / 010-8821-****',
        '강X은 / 010-2256-****',
        '조X호 / 010-6678-****',
        '윤X지 / 010-4491-****',
        '한X수 / 010-1134-****',
        '서X아 / 010-8762-****',
        '임X혁 / 010-3045-****',
        '오X연 / 010-5578-****',
        '신X우 / 010-9203-****',
        '장X린 / 010-6641-****',
        '송X빈 / 010-2917-****',
        '권X태 / 010-4458-****',
        '유X정 / 010-7726-****',
        '배X진 / 010-1382-****',
        '홍X석 / 010-8054-****',
        '문X희 / 010-5239-****',
      ],
      formData: {
        name: '',
        phone1: '010',
        phone2: '',
        phone3: '',
        visitDay: '',
        visitTime: '',
        agree: false
      },
      timeSlots: ['10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00']
    }
  },
  computed: {
    today() {
      return new Date().toISOString().split('T')[0]
    },
    calcCount() {
      const base = 313
      const startDate = new Date('2026-03-28T00:00:00')
      const now = new Date()
      const hours = Math.floor((now - startDate) / (1000 * 60 * 60))
      return base + (hours * 2)
    }
  },
  created() {
    this.applicantCount = this.calcCount
    this.startSlotAnimation()
    this.countTimer = setInterval(() => {
      this.applicantCount = this.calcCount
      this.startSlotAnimation()
    }, 1000 * 60 * 60)
  },
  beforeUnmount() {
    if (this.countTimer) clearInterval(this.countTimer)
    if (this.spinTimer) clearInterval(this.spinTimer)
    window.removeEventListener('open-register-popup', this.openRegister)
  },
  watch: {
    '$route.query.popup'(val) {
      if (val === '1') {
        this.$nextTick(() => {
          this.openRegister()
          this.$router.replace({ path: this.$route.path, query: {} })
        })
      }
    }
  },
  mounted() {
    // 모바일: 홈페이지 또는 v2 진입 시 분양가상한제 → 진라면 → register 순서로 표시
    if ((this.$route.path === '/' || this.$route.path === '/m/version2') && window.innerWidth <= 768) {
      this.$nextTick(() => {
        this.mobilePopupStep = 1
        this.showCallPopup = true
        document.body.style.overflow = 'hidden'
      })
    }
    window.addEventListener('open-register-popup', this.openRegister)
    if (this.$route.query.popup === '1') {
      this.$nextTick(() => {
        this.openRegister()
        this.$router.replace({ path: this.$route.path, query: {} })
      })
    }
  },
  methods: {
    startSlotAnimation() {
      const target = String(this.applicantCount)
      const digits = target.split('')
      this.isSpinning = true
      this.displayDigits = digits.map(() => '0')

      let tick = 0
      const totalTicks = 20
      this.spinTimer = setInterval(() => {
        tick++
        this.displayDigits = digits.map((d, i) => {
          const stopAt = Math.floor(totalTicks * ((i + 1) / digits.length))
          if (tick >= stopAt) return d
          return String(Math.floor(Math.random() * 10))
        })
        if (tick >= totalTicks) {
          clearInterval(this.spinTimer)
          this.displayDigits = digits
          this.isSpinning = false
        }
      }, 80)
    },
    closeCallPopup() {
      // 1단계(분양가상한제) → 2단계(진라면)
      if (this.mobilePopupStep === 1) {
        this.showCallPopup = false
        setTimeout(() => {
          this.mobilePopupStep = 2
          this.showCallPopup = true
        }, 320)
        return
      }

      // 2단계까지 닫힘 → 관심고객등록 열기
      this.showCallPopup = false
      this.$nextTick(() => {
        this.openRegister()
      })
    },
    closeAndRegister() {
      // 전화/상담신청 버튼 클릭 시: 진라면 단계 건너뛰고 즉시 register
      this.showCallPopup = false
      this.$nextTick(() => {
        this.openRegister()
      })
    },
    openRegister() {
      this.showRegister = true
      document.body.style.overflow = 'hidden'
    },
    closeRegister() {
      this.showRegister = false
      document.body.style.overflow = ''
    },
    async submitForm() {
      if (!this.formData.agree) {
        alert('개인정보 수집 및 이용에 동의해주세요.')
        return
      }
      this.isSubmitting = true
      try {
        await registerCustomer({
          name: this.formData.name,
          phone: `${this.formData.phone1}${this.formData.phone2}${this.formData.phone3}`,
          visitDate: this.formData.visitDay && this.formData.visitTime
            ? `${this.formData.visitDay} ${this.formData.visitTime}`
            : this.formData.visitDay || ''
        })
        this.isSubmitted = true

        // 네이버 전환 스크립트 - 신청완료(lead)
        if (window.wcs) {
          if (!window.wcs_add) window.wcs_add = {}
          window.wcs_add['wa'] = 's_40bc4a03dda1'
          var _conv = {}
          _conv.type = 'lead'
          window.wcs.trans(_conv)
        }
      } catch (error) {
        console.error('등록 오류:', error)
        alert('등록 중 오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
        this.isSubmitting = false
      }
    },
    resetForm() {
      this.formData = {
        name: '',
        phone1: '010',
        phone2: '',
        phone3: '',
        visitDay: '',
        visitTime: '',
        agree: false
      }
      this.isSubmitted = false
      this.showPrivacy = false
      this.closeRegister()
    },
    onPhoneInput(field, maxLen, nextRef) {
      this.formData[field] = this.formData[field].replace(/[^0-9]/g, '')
      if (this.formData[field].length >= maxLen && nextRef) {
        this.$refs[nextRef].focus()
      }
    }
  }
}
</script>

<style scoped>
/* ===== 즉시전화 팝업 ===== */
.call-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.call-popup-modal {
  position: relative;
  width: 100%;
  max-width: 340px;
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.call-popup-close {
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(0, 0, 0, 0.08);
  border: none;
  color: #333;
  font-size: 20px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.call-popup-inner {
  padding: 32px 24px 24px;
  text-align: center;
}

.call-badge {
  display: inline-block;
  padding: 5px 14px;
  background: var(--thehue-primary, #004538);
  color: #fff;
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 12px;
  font-weight: 700;
  border-radius: 20px;
  margin-bottom: 12px;
}

.call-title {
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 26px;
  font-weight: 800;
  color: #1a1a1a;
  margin-bottom: 6px;
  letter-spacing: -0.5px;
}

.call-sub {
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 13px;
  color: #888;
}

.call-divider {
  width: 32px;
  height: 2px;
  background: var(--thehue-primary, #004538);
  margin: 18px auto;
  opacity: 0.4;
}

.call-status {
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 13px;
  font-weight: 600;
  color: var(--thehue-primary, #004538);
  letter-spacing: 0.5px;
  margin-bottom: 16px;
}

.call-hero {
  margin: 0 -24px;
  overflow: hidden;
}

.call-hero-img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.call-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 20px 0 0;
  padding: 16px 20px;
  background: var(--thehue-primary, #004538);
  color: #fff;
  border: none;
  border-radius: 12px;
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 15px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.3s ease;
}

.call-btn:active {
  background: var(--thehue-primary-dark, #002e25);
}

.call-btn svg {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.call-btn strong {
  font-family: var(--font-paperlogy, sans-serif);
  font-size: 18px;
  font-weight: 700;
}

.reserve-btn-mobile {
  display: block;
  width: 100%;
  margin: 10px 0 0;
  padding: 16px 20px;
  background: #fff;
  color: var(--thehue-primary, #004538);
  border: 2px solid var(--thehue-primary, #004538);
  border-radius: 12px;
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
}

.reserve-btn-mobile:active {
  background: var(--thehue-primary, #004538);
  color: #fff;
}

.mobile-floating-bar {
  display: none;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 900;
  flex-direction: column;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
}

/* 위: 동호수 빠르게 소진 中 */
.bar-top {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 14px 20px;
  background: var(--sub-color, #f0efe2);
  overflow: hidden;
}

.fake-applicants {
  position: relative;
  height: 22px;
  overflow: hidden;
  min-width: 160px;
}

.fake-item {
  position: absolute;
  top: 0;
  left: 0;
  white-space: nowrap;
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 14px;
  font-weight: 500;
  color: #888;
  line-height: 22px;
  opacity: 0;
  animation: fakeRoll 60s linear infinite;
}

@keyframes fakeRoll {
  0% { opacity: 0; transform: translateY(10px); }
  1% { opacity: 1; transform: translateY(0); }
  4% { opacity: 1; transform: translateY(0); }
  5% { opacity: 0; transform: translateY(-10px); }
  100% { opacity: 0; }
}

.open-text {
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 18px;
  font-weight: 800;
  color: var(--thehue-primary, #004538);
  letter-spacing: -0.02em;
}

/* 둥둥 떠다니는 카운터 */
.float-counter {
  display: none;
  position: fixed;
  bottom: 110px;
  right: 16px;
  background: #fff;
  padding: 10px 16px;
  border-radius: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
  z-index: 899;
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 13px;
  color: #555;
  white-space: nowrap;
  animation: floatBounce 2s ease-in-out infinite;
}

.float-counter::after {
  content: '';
  position: absolute;
  bottom: -6px;
  right: 24px;
  width: 12px;
  height: 12px;
  background: #fff;
  transform: rotate(45deg);
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.06);
}

.count-number {
  font-family: var(--font-paperlogy, 'Paperlogy', sans-serif);
  font-weight: 800;
  color: var(--thehue-primary, #004538);
  font-size: 15px;
}

.slot-digit {
  display: inline-block;
  min-width: 9px;
  text-align: center;
  transition: transform 0.08s ease;
}

.slot-digit.slot-spinning {
  animation: slotFlicker 0.08s steps(1) infinite;
}

@keyframes slotFlicker {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

@keyframes floatBounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
}

/* 아래: 전화 + 관심고객등록 */
.bar-bottom {
  display: flex;
  align-items: stretch;
  background: var(--thehue-primary, #004538);
  padding-bottom: env(safe-area-inset-bottom, 0px);
}

.bar-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 12px;
  text-decoration: none;
  color: #fff;
  min-height: 48px;
  transition: background 0.2s ease;
}

.bar-btn:active {
  background: rgba(255, 255, 255, 0.1);
}

.bar-divider {
  width: 1px;
  background: rgba(255, 255, 255, 0.25);
  margin: 10px 0;
  flex-shrink: 0;
}

.phone-number {
  font-family: var(--font-paperlogy, 'Paperlogy', sans-serif);
  font-size: 17px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.5px;
}

.bar-register {
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 15px;
  font-weight: 700;
  letter-spacing: -0.02em;
  background: transparent;
  border: none;
  color: #fff;
  flex-direction: column;
  gap: 2px;
}

.register-main {
  font-size: 15px;
  font-weight: 700;
  animation: bounce1 2.5s ease-in-out infinite;
}

.register-sub {
  font-size: 10px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.75);
  letter-spacing: 0;
  animation: bounce2 2.5s ease-in-out infinite;
  animation-delay: 0.3s;
}

@keyframes bounce1 {
  0%, 100% { transform: translateY(0); }
  15% { transform: translateY(-6px); }
  30% { transform: translateY(0); }
}

@keyframes bounce2 {
  0%, 100% { transform: translateY(0); }
  15% { transform: translateY(-5px); }
  30% { transform: translateY(0); }
}

/* ===== 관심고객등록 팝업 ===== */
.register-overlay {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 2100;
  align-items: center;
  justify-content: center;
}

.register-modal {
  background: #fff;
  width: 100%;
  max-height: 90vh;
  border-radius: 20px 20px 0 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.register-modal.register-fullform {
  width: 92%;
  max-width: 400px;
  max-height: 85vh;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.register-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #eee;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 1;
}

.register-title {
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
}

.register-close {
  width: 32px;
  height: 32px;
  background: none;
  border: none;
  cursor: pointer;
  position: relative;
}

.register-close span {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 18px;
  height: 2px;
  background: #666;
}

.register-close span:first-child {
  transform: translate(-50%, -50%) rotate(45deg);
}

.register-close span:last-child {
  transform: translate(-50%, -50%) rotate(-45deg);
}

.register-body {
  padding: 24px;
}

.register-coupon-row {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 24px;
}

.register-starbucks-img {
  width: 48px;
  height: 48px;
  object-fit: contain;
  border-radius: 50%;
  flex-shrink: 0;
}

.register-desc {
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 14px;
  color: #888;
  line-height: 1.7;
  margin: 0;
  text-align: left;
}

.register-form .form-group {
  margin-bottom: 20px;
}

.register-form .form-label {
  display: block;
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 13px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.required {
  color: var(--thehue-primary, #004538);
}

.coupon-highlight {
  color: var(--thehue-primary, #004538);
  font-weight: 700;
}

.starbucks-highlight {
  color: #00704A;
  font-weight: 700;
}

.register-form .form-input {
  width: 100%;
  padding: 14px 16px;
  background: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 15px;
  color: #1a1a1a;
  outline: none;
  transition: border-color 0.2s ease;
}

.register-form .form-input:focus {
  border-color: var(--thehue-primary, #004538);
}

.register-form .form-input::placeholder {
  color: #bbb;
}

.visit-inputs {
  display: flex;
  gap: 8px;
}

.visit-field-wrap {
  flex: 1;
  position: relative;
}

.visit-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  color: #999;
  pointer-events: none;
  z-index: 1;
}

.visit-inputs .form-input {
  padding-left: 40px !important;
}

.visit-inputs select.form-input {
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23999' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 14px center;
  padding-right: 36px;
  cursor: pointer;
}

.phone-inputs {
  display: flex;
  align-items: center;
  gap: 6px;
}

.phone-field {
  flex: 1;
  text-align: center;
}

.phone-dash {
  color: #999;
  font-size: 16px;
  flex-shrink: 0;
}

/* 동의 */
.agreement {
  margin-bottom: 24px;
}

.agreement-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.checkbox-input {
  display: none;
}

.checkbox-custom {
  width: 18px;
  height: 18px;
  border: 2px solid #ccc;
  border-radius: 4px;
  background: #fff;
  position: relative;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.checkbox-input:checked + .checkbox-custom {
  background: var(--thehue-primary, #004538);
  border-color: var(--thehue-primary, #004538);
}

.checkbox-input:checked + .checkbox-custom::after {
  content: '✓';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 11px;
}

.checkbox-text {
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 13px;
  color: #333;
}

.toggle-btn {
  background: none;
  border: none;
  font-size: 12px;
  color: #888;
  cursor: pointer;
  text-decoration: underline;
}

.privacy-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
  background: #f5f5f5;
  border-radius: 8px;
}

.privacy-content.visible {
  max-height: 200px;
  padding: 16px;
}

.privacy-content p {
  font-size: 12px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 8px;
}

.privacy-content p:last-child {
  margin-bottom: 0;
}

.privacy-content strong {
  color: #333;
}

/* 제출 */
.submit-btn {
  width: 100%;
  padding: 16px;
  background: var(--thehue-primary, #004538);
  border: none;
  border-radius: 10px;
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
  transition: background 0.2s ease;
}

.submit-btn:active:not(:disabled) {
  background: var(--thehue-primary-dark, #002e25);
}

.submit-btn:disabled {
  opacity: 0.6;
}

/* 성공 */
.register-success {
  padding: 48px 24px;
  text-align: center;
}

.success-icon {
  width: 60px;
  height: 60px;
  border: 2px solid var(--thehue-primary, #004538);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: var(--thehue-primary, #004538);
  margin: 0 auto 20px;
}

.register-success h3 {
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 8px;
}

.register-success p {
  font-size: 14px;
  color: #888;
  margin-bottom: 28px;
}

.reset-btn {
  padding: 12px 40px;
  background: var(--thehue-primary, #004538);
  border: none;
  border-radius: 10px;
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
}

/* 팝업 애니메이션 */
.register-popup-enter-active {
  transition: opacity 0.3s ease;
}

.register-popup-enter-active .register-modal {
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.3s ease;
}

.register-popup-leave-active {
  transition: opacity 0.25s ease;
}

.register-popup-leave-active .register-modal {
  transition: transform 0.25s ease, opacity 0.25s ease;
}

.register-popup-enter-from {
  opacity: 0;
}

.register-popup-enter-from .register-modal.register-fullform {
  transform: scale(0.9);
  opacity: 0;
}

.register-popup-leave-to {
  opacity: 0;
}

.register-popup-leave-to .register-modal.register-fullform {
  transform: scale(0.9);
  opacity: 0;
}

/* 모바일에서만 플로팅바 표시 */
@media (max-width: 768px) {
  .mobile-floating-bar {
    display: flex;
  }

  .float-counter {
    display: block;
  }
}
</style>
